import { useTopKlydos } from "../hooks/useTopKlydos";
import { MapBounds, TopKlydoStats } from "../../../api/admin";
import { parseCloudinaryUrl } from "../../../utils/util";
import DSTableContainer from "../../system-design/Table/DSTableContainer";
import DSTable from "../../system-design/Table/DSTable";
import DSTableHead from "../../system-design/Table/DSTableHead";
import DSTableBody from "../../system-design/Table/DSTableBody";
import DSTableRow from "../../system-design/Table/DSTableRow";
import DSTableCell from "../../system-design/Table/DSTableCell";
import DSBox from "../../system-design/DSBox";
import {
  LoadingState,
  ErrorState,
  EmptyState,
  SummaryBar,
  MEDIA_STYLE,
  ID_CELL_STYLE,
} from "./StatsDialog";

type KlydosStatsContentProps = {
  bounds: MapBounds;
  limit: number;
  open: boolean;
  isGlobal: boolean;
};

const KlydosTable = ({ klydos }: { klydos: TopKlydoStats[] }) => (
  <DSTableContainer>
    <DSTable>
      <DSTableHead>
        <DSTableRow>
          <DSTableCell>Preview</DSTableCell>
          <DSTableCell>Klydo Name</DSTableCell>
          <DSTableCell>Klydo ID</DSTableCell>
          <DSTableCell align="right">Usage Count</DSTableCell>
        </DSTableRow>
      </DSTableHead>
      <DSTableBody>
        {klydos.map((klydo) => (
          <DSTableRow key={klydo.klydoId}>
            <DSTableCell>
              <video
                src={parseCloudinaryUrl({ url: klydo.loopUrl, size: 100 })}
                autoPlay
                loop
                muted
                playsInline
                style={MEDIA_STYLE}
              />
            </DSTableCell>
            <DSTableCell>{klydo.name}</DSTableCell>
            <DSTableCell sx={ID_CELL_STYLE}>{klydo.klydoId}</DSTableCell>
            <DSTableCell align="right">
              <DSBox sx={{ fontWeight: "bold", color: "primary.main" }}>
                {klydo.usageCount}
              </DSBox>
            </DSTableCell>
          </DSTableRow>
        ))}
      </DSTableBody>
    </DSTable>
  </DSTableContainer>
);

const KlydosStatsContent = ({
  bounds,
  limit,
  open,
  isGlobal,
}: KlydosStatsContentProps) => {
  const { topKlydos, totalCount, isLoading, isFetching, error } = useTopKlydos(
    bounds,
    limit,
    open,
    isGlobal,
  );

  if (isLoading || isFetching) return <LoadingState />;
  if (error) return <ErrorState message={error.message} />;

  return (
    <>
      <SummaryBar
        itemCount={topKlydos.length}
        totalCount={totalCount}
        tabLabel="klydos"
      />
      {topKlydos.length === 0 ? (
        <EmptyState isGlobal={isGlobal} type="klydos" />
      ) : (
        <KlydosTable klydos={topKlydos} />
      )}
    </>
  );
};

export default KlydosStatsContent;
